import { render, staticRenderFns } from "./EditLetter.vue?vue&type=template&id=50c118e7"
import script from "./EditLetter.vue?vue&type=script&lang=js"
export * from "./EditLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50c118e7')) {
      api.createRecord('50c118e7', component.options)
    } else {
      api.reload('50c118e7', component.options)
    }
    module.hot.accept("./EditLetter.vue?vue&type=template&id=50c118e7", function () {
      api.rerender('50c118e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/LetterTemplate/EditLetter.vue"
export default component.exports